/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Titles_Pagenotfounddescription3Inputs */

const en_titles_pagenotfounddescription3 = /** @type {(inputs: Titles_Pagenotfounddescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page you are looking for can not be found.`)
};

/**
* | output |
* | --- |
* | "The page you are looking for can not be found." |
*
* @param {Titles_Pagenotfounddescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const titles_pagenotfounddescription3 = /** @type {((inputs?: Titles_Pagenotfounddescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Titles_Pagenotfounddescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_titles_pagenotfounddescription3(inputs)
});
export { titles_pagenotfounddescription3 as "titles_pageNotFoundDescription" }